// extracted by mini-css-extract-plugin
export default {"wrapper":"cjuNHvl8gt","header":"jc7X2uydSD","title":"zVKNIxZCQu","input":"c4LMVL8z7b","errors":"Z6fkgc5nbN","error":"c5KWcrbQX_","dark":"KLJUoa53tW"};